import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import type { ButtonProps } from "./ButtonProps";

export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    href: {},
    label: {},
    textColor: {},
    backgroundColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0f9867b2": (_ctx.backgroundColor),
  "0d64c8d3": (_ctx.textColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "flex-none rounded-full px-3.5 py-1 text-sm font-semibold shadow-sm"
  }, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
  ], 8, _hoisted_1))
}
}

})